export default {
  fileSize: 64,
  fileMargin: 10
};
